export const Separator = () => <hr className="border-neutral-medium-lighter w-full" />
